import React, { ReactNode } from 'react';

interface Attrs {
  [key: string]: string;
}

export const withAttrs = (t: string | ReactNode, attrs: Attrs): ReactNode => {
  return <span {...attrs}>{t}</span>;
};
